import * as angular from "angular";
import {IWindowService} from "angular";
import {ApiConfig} from "../modules/commons/models/api-config.model";
import {SiteContextService} from "../modules/commons/services/site-context.service";
import {SplitService} from "../modules/commons/services/split-service.service";

export class UserService {

  private storage: any;
  private currentUser: any;

  /* @ngInject */
  constructor(private $window: IWindowService, private apiConfig: ApiConfig, private $q, private splitService: SplitService,
              private $http, private siteContextService: SiteContextService) {
    this.storage = this.$window.localStorage;
  }

  getUser() {
    const deferred = this.$q.defer();

    this.$http.get(`${this.apiConfig.baseUrl}/iam/user`)
      .then((response) => {
        this.setCurrentUser(response.data.user, response.data.userHash);
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }

  getUsers(userIds?: string[], searchTerm?: string) {
    const deferred = this.$q.defer();

    this.$http.get(`${this.apiConfig.baseUrl}/iam/users`, {
      params: {
        siteId: this.splitService.getSiteId(),
        ids: userIds,
        searchTerm
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }

  updateUserLastActive() {
    const deferred = this.$q.defer();

    this.$http.post(`${this.apiConfig.baseUrl}/iam/lastActiveDate`)
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }


  getCurrentUser() {
    if (!angular.isDefined(this.currentUser)) {
      const storageUser = this.storage.getItem('user');
      this.currentUser = storageUser ? JSON.parse(storageUser) : undefined;
    }
    return this.currentUser;
  }

  setCurrentUser(user, userHash) {
    this.currentUser = {
      displayName: !!user.nickname ? user.nickname : (user.firstName + ' ' + user.lastName),
      id: user.id,
      email: user.email,
      avatar: user.pictureUrl,
      userHash: userHash
    };

    this.storage.setItem('user', JSON.stringify(this.currentUser));
  }

  login(data) {
    const user = data.user;

    this.currentUser = {
      displayName: !!user.nickname ? user.nickname : (user.firstName + ' ' + user.lastName),
      id: user.id,
      email: user.email,
      avatar: user.pictureUrl,
      userHash: data.userHash
    };

    this.storage.setItem('user', JSON.stringify(this.currentUser));
  }

  // logout() {
  //   this.currentUser = undefined;
  //   this.storage.removeItem('user');
  // }

  logout() {
    const deferred = this.$q.defer();

    this.$http.post(`${this.apiConfig.baseUrl}/iam/logout`)
      .then((response) => {
        this.currentUser = undefined;
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }


  getUserOperationalData() {
    const deferred = this.$q.defer();

    this.$http.get(`${this.apiConfig.baseUrl}/iam/users/userOperationalData`, {
      params: {
        siteId: this.splitService.getSiteId(),
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }


}

angular
  .module('app.permission')
  .service('UserService', UserService);
